import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

/* library */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import $ from 'jquery';
/* style */

import './DropList.css';

var DropList = /*#__PURE__*/function (_Component) {
  _inherits(DropList, _Component);

  var _super = _createSuper(DropList);

  function DropList() {
    var _this;

    _classCallCheck(this, DropList);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "state", {
      isPop: false,
      scrollTop: 0,
      isOptionLoaded: false,
      searchOption: '',
      keyword: ''
    });

    _defineProperty(_assertThisInitialized(_this), "updateTime", Date.now());

    _defineProperty(_assertThisInitialized(_this), "keyword", '');

    _defineProperty(_assertThisInitialized(_this), "startWith", function (str, prefix) {
      return str.substr(0, prefix.length) === prefix;
    });

    _defineProperty(_assertThisInitialized(_this), "handleBarClick", function () {
      var isOptionLoaded = true; //console.log('hl (state) isPop: ', this.state.isPop, ', (props) isPop: ', this.props.isPopOutside)

      var nextPopStatus = !_this.state.isPop;

      if (nextPopStatus == true) {
        isOptionLoaded = false;

        if (_this.props.onChangeStatus) {
          _this.props.onChangeStatus('true'); // 選單開啟

        }
      } else {
        if (_this.props.onChangeStatus) {
          _this.props.onChangeStatus('none'); // 選單還原成初始值

        }
      }

      _this.setState({
        isPop: !_this.state.isPop,
        isOptionLoaded: isOptionLoaded,
        searchOption: ''
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleItemClick", function (optValue) {
      //console.log('hl option value: ', optValue)
      if (_this.props.onChangeSelected) {
        _this.props.onChangeSelected(optValue);
      }

      var isOptionLoaded = true;
      if (!_this.state.isPop) isOptionLoaded = false;

      _this.setState({
        isPop: !_this.state.isPop,
        isOptionLoaded: isOptionLoaded,
        searchOption: ''
      });
    });

    return _this;
  }

  _createClass(DropList, [{
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.props.openSearch) {
        $(document).off('keypress');
      }
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var scrollToIndex = this.props.scrollToIndex;

      if (scrollToIndex != undefined) {
        this.setState({
          scrollTop: scrollToIndex * 20
        });
      }

      var self = this; // the instance that jquery library could access

      if (this.props.autoSearch) {
        $(document).on('keypress', function (e) {
          var _this2 = this;

          //console.log('hl key code: ', e.keyCode, ', char: ', String.fromCharCode(e.keyCode))
          try {
            if (self.state.isPop) {
              if (e.keyCode == 13) {
                // Press 'Enter' key
                var _findIndex = -1;

                self.props.list.map(function (option, index) {
                  var res = self.startWith(option.text, _this2.keyword); // console.log('hl start with? ', res, ', text: ', option.text, ', keyword: ', this.keyword)

                  if (res) {
                    //console.log('hl findIndex: ', index);
                    if (_findIndex == -1) _findIndex = index;
                  } else {// check whether this option's text contains keyword
                    // let idx = option.text.indexOf(this.keyword)
                    // if (idx >= 0 && findIndex == -1) {
                    //     findIndex = index;
                    // }
                  }
                });

                if (_findIndex >= 0) {
                  //self.handleItemClick(this.keyword);
                  self.handleItemClick(_findIndex);
                }
              } //console.log('hl key: ', String.fromCharCode(e.keyCode))


              var inputChar = String.fromCharCode(e.keyCode);
              var currentTime = Date.now();

              if (currentTime - this.updateTime > 600) {
                this.keyword = '';
              }

              if (this.keyword == undefined) this.keyword = inputChar;else this.keyword += inputChar; //console.log('hl keyword: ', this.keyword);

              var findIndex = -1,
                  optionValue = '';
              self.props.list.map(function (option, index) {
                var res = self.startWith(option.text, _this2.keyword); // console.log('hl start with? ', res, ', text: ', option.text, ', keyword: ', this.keyword)

                if (res) {
                  //console.log('hl findIndex: ', index);
                  if (findIndex == -1) {
                    findIndex = index;
                    optionValue = option.text;
                  }
                } else {// check whether this option's text contains keyword
                  // let idx = option.text.indexOf(this.keyword)
                  // if (idx >= 0 && findIndex == -1) {
                  //     findIndex = index;
                  //     optionValue = option.text;
                  // }
                }
              }); //console.log('hl index: ', findIndex)

              if (findIndex >= 0) {
                var scrollTop = findIndex * 20;
                var top = scrollTop; //console.log('hl top: ', top);

                if (scrollTop > 139) {
                  // the selected option is located at the bottom
                  top = scrollTop - 120 + 2;
                  if (top < 0) top = 0;
                  self.refs.content.scrollTop = top;
                } else {
                  self.refs.content.scrollTop = 0;
                }
              }

              self.setState({
                searchOption: optionValue,
                keyword: this.keyword
              });
              this.updateTime = currentTime;
            }
          } catch (e) {
            console.error('keypress fail', e);
          }
        });
      }
    }
  }, {
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.selected != undefined && nextProps.selected !== this.props.selected) {
        //console.log('hl scroll top: ', nextProps.selected * 20)
        // (DropList.css) each <li> height: 20px
        if (Number(nextProps.selected) != NaN) {
          // valid index
          if (Number(nextProps.selected) < nextProps.list.length && Number(nextProps.selected) >= 0) {
            this.setState({
              scrollTop: Number(nextProps.selected) * 20
            });
          }
        }
      }

      if (nextProps.scrollToIndex != undefined && nextProps.scrollToIndex !== this.props.scrollToIndex) {
        //console.log('hl scroll top: ', nextProps.selected * 20)
        // (DropList.css) each <li> height: 20px
        this.setState({
          scrollTop: Number(nextProps.scrollToIndex) * 20
        });
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      //console.log('hl update scroll top: ', this.state.scrollTop)
      var _this$state = this.state,
          scrollTop = _this$state.scrollTop,
          isOptionLoaded = _this$state.isOptionLoaded;

      if (!isOptionLoaded) {
        if (this.refs.content) {
          var top = scrollTop; //console.log('hl top: ', top);

          if (scrollTop > 139) {
            // the selected option is located at the bottom
            top = scrollTop - 120 + 2;
            if (top < 0) top = 0;
            this.refs.content.scrollTop = top;
            this.setState({
              isOptionLoaded: true
            });
          }
        }
      } // Hide option from ouside component


      if (this.props.isPopOutside == 'false' && this.state.isPop == true) {
        this.setState({
          isPop: false
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var optStyle = {
        paddingLeft: '5px'
      }; // put text of the selected option

      var placeHolder = this.props.placeHolder;
      this.props.list.map(function (option) {
        if (option.value === _this3.props.selected) {
          placeHolder = /*#__PURE__*/React.createElement("span", {
            onClick: function onClick(e) {
              _this3.handleBarClick();

              e.stopPropagation();
            }
          }, option.text, "  ", option.content);
        }
      });
      return /*#__PURE__*/React.createElement("div", {
        id: "DropList",
        tabIndex: "0",
        className: this.props.disabled ? 'disabled' : '',
        onClick: function onClick(e) {
          e.stopPropagation();
        },
        onBlur: function onBlur() {
          _this3.setState({
            isPop: false
          });
        }
      }, /*#__PURE__*/React.createElement("div", {
        className: "bar",
        style: this.props.style != {} ? this.props.style : {},
        onClick: function onClick(e) {
          _this3.handleBarClick();

          e.stopPropagation();
        }
      }, placeHolder), this.state.isPop && this.props.isPopOutside !== 'false' && !this.props.disabled ? /*#__PURE__*/React.createElement("ul", {
        ref: "content"
      }, this.props.list.map(function (option, index) {
        if (_this3.props.disableOptions && _this3.props.disableOptions.indexOf(option.value) > -1) {
          return /*#__PURE__*/React.createElement("li", {
            style: optStyle,
            key: "droplist_option_".concat(index),
            className: "disable"
          }, option.text);
        }

        if (option.disable) {
          return /*#__PURE__*/React.createElement("li", {
            style: optStyle,
            key: "droplist_option_".concat(index),
            className: "disable"
          }, option.text);
        }

        var selectedStyle = ''; // if (option.value == this.state.searchOption) selectedStyle = 'searched';

        if (option.value == _this3.props.selected) selectedStyle = 'selected';

        var renderTextWithKeyword = function renderTextWithKeyword(optionText, keyword) {
          if (optionText == _this3.state.searchOption) {
            var startIndex = optionText.indexOf(keyword);

            if (startIndex < 0) {
              return optionText;
            } else {
              return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("span", {
                className: "common"
              }, optionText.substring(0, startIndex)), /*#__PURE__*/React.createElement("span", {
                className: "keyword"
              }, keyword), /*#__PURE__*/React.createElement("span", {
                className: "common"
              }, optionText.substring(startIndex + keyword.length)));
            }
          } else {
            return optionText;
          }
        }; // console.log('hl text: ', option.text, ', content: ', option.content);


        var displayText = option.text ? option.text : '';
        return /*#__PURE__*/React.createElement("li", {
          title: displayText,
          style: optStyle,
          key: "droplist_option_".concat(index),
          className: selectedStyle,
          onClick: function onClick(e) {
            _this3.handleItemClick(option.value);

            e.stopPropagation();
          }
        }, renderTextWithKeyword(option.text, _this3.state.keyword), " ", option.content);
      })) : null);
    }
  }]);

  return DropList;
}(Component);

DropList.defaultProps = {
  autoSearch: false,
  style: {}
};
/* 
 * A React (complex-select) Drop List
 * @param {string} [isPopOutside] - 由外部控制是否關閉選單。
 * @param {node} [selected] - 已選擇的 選項索引 或 文字鍵值。
 *                            若為 索引, 則捲動至此索引選項; 若為文字鍵值, 則捲動至 scrollToIndex 之選項。 
 * @param {number} [scrollToIndex] - 捲動至此索引之選項。
 * @param {Array.<Object.<node, string, node>>} [list] - 選項列表。
 * @param {Array.<string>} [disableOptions] - 停用之選項。
 * @param {string} [placeHolder] - 呈現文字。
 * @param {bool} [disabled] - 停用功能。
 * @param {object} [style] - 提供外部元件調整樣式的參數, 如 height、padding、margin...等。
 * @param {bool} [autoSearch] - 開啟選項列表後, 當使用者於鍵盤輸入若干字元(字串)後自動捲動至符合輸入的項目, 此功能預設關閉。
 * @param {function} onChangeSelected(popStatus) - 當選項改變時, 所觸發的回呼函式。
 * @param {function} onChangeStatus(optionValue) - 當選單狀態改變(開啟/關閉)時, 所觸發的回呼函式。
 */

DropList.propTypes = {
  isPopOutside: PropTypes.string,
  selected: PropTypes.node,
  scrollToIndex: PropTypes.number,
  list: PropTypes.arrayOf(PropTypes.shape({
    value: PropTypes.node,
    text: PropTypes.string,
    content: PropTypes.node
  })),
  disableOptions: PropTypes.array,
  placeHolder: PropTypes.string,
  disabled: PropTypes.bool,
  style: PropTypes.object,
  autoSearch: PropTypes.bool,
  onChangeSelected: PropTypes.func,
  onChangeStatus: PropTypes.func
};
export default DropList;